export const ACTIVITY_STATES = Object.freeze({
  COMPLETE: "complete",
  DECLARED_NOT_DONE: "declaredNotDone",
  OVERDUE: "overdue",
  UPCOMING: "upcoming",
  DEFAULT_INCOMPLETE: "defaultIncomplete",
});

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function resolveActivityCompletionState(activity, now = new Date()) {
  if (!activity) return ACTIVITY_STATES.DEFAULT_INCOMPLETE;

  const current = toDate(now) ?? new Date();
  const start = toDate(activity.start_time);
  const isComplete =
    activity.event_state === "completed" || activity.event_state === "complete";

  if (isComplete) return ACTIVITY_STATES.COMPLETE;
  if (activity.client_marked_not_done_at) {
    return ACTIVITY_STATES.DECLARED_NOT_DONE;
  }
  if (start && current < start) return ACTIVITY_STATES.UPCOMING;
  if (start && current >= start) return ACTIVITY_STATES.OVERDUE;
  return ACTIVITY_STATES.DEFAULT_INCOMPLETE;
}

export function getActivityCompletionLabel(activity, now = new Date()) {
  switch (resolveActivityCompletionState(activity, now)) {
    case ACTIVITY_STATES.COMPLETE:
      return "Complete";
    case ACTIVITY_STATES.DECLARED_NOT_DONE:
      return "Marked not done";
    default:
      return "Incomplete";
  }
}

export function getActivityCompletionCsvStatus(activity, now = new Date()) {
  return getActivityCompletionLabel(activity, now);
}

export function getActivityCompletionButtonClass(activity, now = new Date()) {
  switch (resolveActivityCompletionState(activity, now)) {
    case ACTIVITY_STATES.COMPLETE:
      return "complete-button";
    case ACTIVITY_STATES.DECLARED_NOT_DONE:
      return "declared-not-done-button";
    default:
      return "incomplete-button";
  }
}

export function shouldShowActivityCompletionBadge(activity, now = new Date()) {
  const state = resolveActivityCompletionState(activity, now);
  return (
    state !== ACTIVITY_STATES.UPCOMING &&
    state !== ACTIVITY_STATES.DEFAULT_INCOMPLETE
  );
}
